import { render } from "./sub-modals.vue?vue&type=template&id=16874a7c"
import script from "./sub-modals.vue?vue&type=script&lang=js"
export * from "./sub-modals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__